<template>
  <div>
    <b-row align-v="end">
      <b-col>
        <BaseELabel label="Select Action Date Range" />
        <!-- <DatePicker
          v-model="range"
          is-range
          :masks="masks"
          :model-config="modelConfig"
        >
          <template v-slot="{ inputValue, togglePopover }">
            <b-input-group class="mt-3">
              <b-input-group-prepend>
                <BaseEButton
                  class="focus:border-none focus:outline-none d-inline primary"
                  icon="calendar"
                  variant="icon"
                  @click="togglePopover"
                />
              </b-input-group-prepend>

              <b-form-input
                :value="`${inputValue.start || ''} - ${inputValue.end || ''}`"
                class="form-control d-inline"
                readonly
              ></b-form-input>
            </b-input-group>
          </template>
        </DatePicker> -->
        <BaseDate
          v-model="range"
          placeholder="Select date"
          :field-id="'filterDate'"
          type="date"
          name="filterDate"
          mode="range"
        ></BaseDate>
      </b-col>
      <b-col>
        <BaseEButton @click="getFilteredData(range)">Apply Filter</BaseEButton>
      </b-col>
    </b-row>
  </div>
</template>
<script>
// import DatePicker from 'v-calendar/lib/components/date-picker.umd'
export default {
  // components: { DatePicker },
  data() {
    return {
      range: '',
      // masks: {
      //   input: 'MM/DD/YYYY',
      // },
      // modelConfig: {
      //   type: 'string',
      //   mask: 'MM/DD/YYYY',
      // },
    }
  },

  methods: {
    getFilteredData(range) {
      this.$emit('getFilteredLoans', range)
    },
  },
}
</script>
